export default __webpack_public_path__ + "static/media/fpb10004.573da694.png";